import './card-style.css';
import { Link } from "react-router-dom";
import DOMPurify from 'dompurify';
import linesAmc from '../../assets/imgs/track/lines.svg';

const sanitizeUrl = (url) => {
  if (!url || typeof url !== 'string') return '#';
  const trimmed = url.trim();
  if (/^(https?:\/\/|\/|\.\/|#)/i.test(trimmed) && !/^(javascript|data|vbscript):/i.test(trimmed)) {
    return DOMPurify.sanitize(trimmed);
  }
  return '#';
};

function Card(props) {
  const convertTextUpper = props.btnMessage ? props.btnMessage.toUpperCase() : '';
  const imageSrc = props.image ? DOMPurify.sanitize(props.image) : '';
  const showLines = props.showLines !== false;
  const imageLinkTo = props.redirectHref;
  const imageIsClickable =
    typeof imageLinkTo === 'string' &&
    imageLinkTo.length > 0 &&
    imageLinkTo !== '#';
  const imageAriaLabel = props.title
    ? `Ir a ${props.title}`
    : 'Ir al servicio';

  const renderButton = () => {
    if (props.btnMessage !== undefined || props.redirectBtn !== undefined) {
      const safeRedirectBtn = sanitizeUrl(props.redirectBtn);

      // Si la URL no es válida o es insegura (#), no renderizamos un enlace roto o peligroso
      if (safeRedirectBtn === '#') return null;

      return (
        <a
          href={safeRedirectBtn}
          target='_blank'
          rel='noopener noreferrer'
          className="primary-btn"
        >
          {convertTextUpper}
        </a>
      );
    }
    return null;
  };

  const renderTitle = () => {
    if (props.icon !== undefined || props.title !== undefined) {
      return (
        <div className='text'>
          <i>
            {props.icon}
          </i>
          <h3>{[props.title]}</h3>
        </div>
      )
    } else {
      return (
        <>
          <img className='imgTitle' src={imageSrc} alt='AMC Internationals' />
        </>
      )
    }
  }

  return (
    <>
      <div className='targetContentCard'>
        <div className='imgContent'>
          {imageIsClickable ? (
            <Link
              to={imageLinkTo}
              className='imgContentLink'
              aria-label={imageAriaLabel}
              id={props.linkId ? `${props.linkId}-image` : undefined}
            >
              <img src={imageSrc} alt="" />
            </Link>
          ) : (
            <img src={imageSrc} alt={props.title || ''} />
          )}
        </div>
        <div className='titleCard'>
          {showLines && <img className='lines' src={linesAmc} alt='' aria-hidden='true' />}
          {renderTitle()}
        </div>

        <div className='textContetCard'>
          <p>
            {props.description}
          </p>

          <div className="actions">
            <Link to={props.redirectHref} id={props.linkId} className='redirecPageTo'>{props.redirect}</Link>
            <div>
              {renderButton()}
            </div>
          </div>
        </div>

      </div>

    </>
  );
}

export default Card;
